module.exports = __webpack_public_path__ + "img/bg10.351be79b.png";